import React from 'react';
import './_styles.scss';
import { LocalAssets } from '../../requests/apa/local';
import assetsJson from './assets.json';

const localAssets = new LocalAssets(assetsJson);

const LoadingScreen = () => {
  const getBackgroundStyle = () => {
    const asset = localAssets.get('Onboarding2_Imagen_PantallaCarga_1', 'null');
    const logo = `${process.env.PUBLIC_URL || ''}/Claro-logo.png`;

    const commonStyles = {
      backgroundColor: 'black',
      backgroundPosition: 'center center',
    };

    if (asset && asset !== 'null') {
      return {
        ...commonStyles,
        backgroundImage: `url(${asset})`,
        backgroundSize: 'cover',
      };
    } else {
      return {
        ...commonStyles,
        backgroundImage: `url(${logo})`,
        backgroundRepeat: 'no-repeat',
      };
    }
  };

  return <div style={getBackgroundStyle()} className="loading-screen"></div>;
};

export default LoadingScreen;


// WEBPACK FOOTER //
// ./src/components/LoadingScreen/index.jsx